<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card>
                <v-list two-line>
                    <template v-for="(clazz, index) in classes">
                        <v-list-tile
                                :key="clazz.name"
                                avatar
                                ripple
                                @click="navigateToClassDetails(clazz.id)"
                        >
                            <v-list-tile-avatar>
                                <v-icon>supervised_user_circle</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ clazz.name }}</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{ clazz.description || '' }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="navigateToClassHistory(clazz.id)">
                                    <v-icon color="grey lighten-1">trending_up</v-icon>
                                </v-btn>
                            </v-list-tile-action>

                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < classes.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        data() {
            return {
                classes: undefined
            }
        },

        methods: {
            navigateToClassDetails(classId) {
                this.$router.push({
                    name: 'class',
                    params: {
                        id: classId
                    }
                });
            },
            navigateToClassHistory(classId) {
                this.$router.push({
                    name: 'class-history-chart',
                    query: {classId: classId}
                })
            }
        },

        mounted() {
            this.$store.dispatch('getClasses').then((cList) => {
                if (!cList || !cList.length) {
                    return Promise.reject('Unable to get classes information');
                }
                this.classes = cList
            });
        }
    }
</script>
